import {useState,React} from 'react';
import './styles.css';
import './homepage.css';
import '../App.css';
import './Project.css';
import BottomBar from './BottomBar';
import { IonIcon } from '@ionic/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper';
// import './flower.css';
import ProjectCard from './ProjectCard';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Footer from './Footer'
import { Link } from 'react-router-dom';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import p1 from '../images/img_1.jpg';
import VideoModal from './VideoModal';
import CircularMenu from './CircularMenu';
const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const projects = [
    {
      image: './efacteur.png',
      title: 'E - Facteur',
      description: 'A comprehensive web application for efficient online courier service management.E-Facteur aims to revolutionize package delivery by addressing user challenges like pricing transparency and service reliability.',
      link: 'https://github.com/siyagampawar/E-facteur'
    },
    {
      image: './insightpune.png',
      title: 'InsightPune',
      description: 'InsightPune is a groundbreaking solution addressing the prevalent challenges of fragmented information and the absence of a user-friendly, centralized platform for comprehensive insights about Pune.',
      link: 'https://github.com/siyagampawar/InsightPune'
    },
    {
      image: './budgetbuddy.png',
      title: 'Budget Buddy',
      description: 'Budget Buddy allows users to log their income and expenses, provides a new way of Systematic Savings Plan, and get insights into their spending habits. Additionally, the integrated chatbot provides helpful tips and suggestions to improve financial literacy.',
      link: 'https://github.com/siyagampawar/Budget-Buddy'
    },
    {
      image: './ecommerce.png',
      title: 'Ecommerce Backend',
      description: 'Developed a robust backend system to support an e-commerce platform. Implemented various features such as user authentication, cart management, buying options, and cart checkout.',
      link: 'https://github.com/siyagampawar/ecommerce-backend-go'
    },
    {
      image: './sign.png',
      title: 'Sign Language Detector',
      description: 'Implemented various Deep learning and Machine learning algorithms like CNN, VGG – 16, ResNet, EfficientNet, etc.',
      link: 'https://github.com/siyagampawar/Sign-Language-Detector'
    },
    {
      image: './crc.png',
      title: 'CRC Generator',
      description: 'Website to generate CRC (Cyclic Redundancy Check) and check the received message for error detection and improving data reliability. Aims in generating CRC through polynomial as well as binary divisor.',
      link: 'https://github.com/siyagampawar/CRC-Generator'
    },
    {
      image: './rentcar.png',
      title: 'RentCar',
      description: 'Aimed to provide a transparent interface to users for easy booking. Users can login to the website and easily select their pickup and drop location, date of travel, and number of people to book RentCar for their trip.',
      link: 'https://github.com/siyagampawar/RentCar-App'
    },
    {
      image: './todo.png',
      title: 'TODO APP',
      description: 'React application for task management, including features to add, remove, and edit tasks.',
      link: 'https://github.com/siyagampawar/To-Do-App'
    }
  ];
const Projects = () => {
    // const navigate = useNavigate();

    // function redirectToProjectsPage() {
    //     navigate('/projects', { replace: true });
    // }
    const [showModal, setShowModal] = useState(false);

const handleOpenModal = () => {
  setShowModal(true);
}

const handleCloseModal = () => {
  setShowModal(false);
}
    return (
        <div class="homepagedark">
      <div class="bg1">
        <div class="bg-item"></div>
        {/* <div class="line-group">
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
        </div> */}
      </div>
      <div class="ololade-group">
        <div class="ololade2">
          <span>PROJECTS</span>
          <span class="span2">.</span>
        </div>
        {/* <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button> */}
      </div>
      <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 680,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 830,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>
</div>
        
        
      </div>
      <div className="container">
      <h1 className="heading">Portfolio</h1>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
        }}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true,
        }}
        className="swiper_container"
      >
        {projects.map((project, index) => (
          <SwiperSlide key={index}>
            <ProjectCard
              image={project.image}
              title={project.title}
              description={project.description}
              link={project.link}
            />
          </SwiperSlide>
        ))}

        <div className="slider-controler">
          <div className="swiper-button-prev slider-arrow" style={{width:'20px',height:'20px'}}>
            {/* <ion-icon name="arrow-back-outline"></ion-icon> */}
          </div>
          <div className="swiper-button-next slider-arrow"style={{width:'20px',height:'20px'}}>
            {/* <ion-icon name="arrow-forward-outline"></ion-icon> */}
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </Swiper>
    </div>
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    bottom: 370,
    right: 50,
  }}>
    <CircularMenu />
  </div>
</div>
    </div>
    );
};

export default Projects;
